import axios from "axios";
import host from "../global";
import Cookies from "js-cookie";

export const getScreenedCandidatesService = async (jdId) => {
  try {
    const accessToken = Cookies.get("accessToken");

    if (!accessToken) {
      window.location.href = "/";
      return [];
    }

    const response = await axios.get(`${host}/resumes/bulk`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      params: {
        jd_id: jdId
      }
    });

    if (!response.data) {
      return [];
    }
    return response.data
  } catch (error) {
    console.log("Somthing Went Wrong While Fetching Candidate Data ");
    console.log({ error });
    return [];
  }
}


export const updateCandidateEmailService = async (
  upload_id,
  unique_id,
  new_email,
  isSourcedCandidate=false,
  new_contact=null
) => {
  try {
    const accessToken = Cookies.get("accessToken");

    const response = await axios.put(
      `${host}/update_candidate_email`,
      null, // no body, params are in query
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        params: {
          upload_id,
          unique_id,
          new_email,
          new_contact,
          isSourcedCandidate
        },
      }
    );

    // ✅ success
    return response?.data?.message?.includes("updated successfully");
  } catch (error) {
    console.error("Error occurred while updating candidate info", error);
    return false;
  }
};


export const scheduleMyUploadsCandidateInterviews = async ({
  uploadId,
  uniqueIds,
  startDate,
  endDate,
  org_id,
  timezone,
  timeslot,
}) => {
  try {
    const payload = {
      unique_ids: uniqueIds,
      start_date: startDate,
      end_date: endDate,
      // Always send a valid timezone string; fall back to browser/system timezone
      timezone: timezone && timezone.trim() ? timezone : Intl.DateTimeFormat().resolvedOptions().timeZone,
      // timeslot is null when the user did not select a specific time slot
      timeslot: timeslot && timeslot.trim() ? timeslot : null,
    };
    const accessToken = Cookies.get("accessToken");

    const response = await axios.post(
      `${host}/schedule_interviews`,
      payload,
      {
        params: { upload_id: uploadId, org_id },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error occurred while scheduling candidate Interviews", error);
    return false;
  }
}




export const scheduleInterviewsFromSourcedProfileService = async ({
  candidates,
  dateRange,
  org_id,
  timezone,
  timeslot,
}) => {
  const accessToken = Cookies.get("accessToken");

  const unscheduledCandidates = candidates.filter(
    (c) => !(c.interview_id && c.status === "scheduled")
  );

  if (unscheduledCandidates.length === 0) {
    return {
      successCount: 0,
      skippedCount: candidates.length,
      scheduledIds: [],
    };
  }

  // Resolve timezone once for all candidates in this batch
  const resolvedTimezone =
    timezone && timezone.trim()
      ? timezone
      : Intl.DateTimeFormat().resolvedOptions().timeZone;
  // timeslot is null when not using specific time slots
  const resolvedTimeslot = timeslot && timeslot.trim() ? timeslot : null;

  const schedulePromises = unscheduledCandidates.map(async (candidate) => {
    try {
      /** 1️⃣ Fetch JD */
      const { data: jobConfig } = await axios.get(`${host}/getjd`, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params: { jd_id: candidate.jd_id || candidate.job_id },
      });

      /** 2️⃣ Build FormData */
      const formData = new FormData();
      formData.append("name", candidate.name);
      formData.append("candidate_email", candidate.candidate_email);
      formData.append("mcq_set_id", jobConfig.mcq_set_id || "");
      formData.append(
        "Coding_Judge_Criteria",
        JSON.stringify(jobConfig.Coding_Judge_Criteria || [])
      );
      formData.append("coding_set", jobConfig.Coding_set || "");
      formData.append("mcq_time_limit", jobConfig.mcq_time_limit || 0);
      formData.append("coding_time_limit", jobConfig.coding_time_limit || 0);
      formData.append("typing_time_limit", jobConfig.typing_time_limit || 0);
      formData.append("selected_behavioral_set", jobConfig.selected_behavioral_set || "");

      formData.append("start_date", dateRange[0].toISOString());
      formData.append("end_date", dateRange[1].toISOString());

      formData.append("job_id", candidate.jd_id || candidate.job_id);
      formData.append("job_role", jobConfig.jobrole || "");
      formData.append(
        "job_description",
        JSON.stringify(jobConfig.description || {})
      );

      formData.append("resume_content", candidate.resume_content || "");
      formData.append("resume_s3_url", candidate.resume_s3_url || "");
      formData.append("score", candidate.score || 0);
      formData.append("interview_type", jobConfig.interview_type || "");
      formData.append("questionType", jobConfig.questionType || "");
      formData.append(
        "interview_timelimit",
        jobConfig.interview_timelimit || 0
      );
      formData.append("report", JSON.stringify(candidate.report || {}));
      formData.append(
        "education_match",
        JSON.stringify(candidate.education_match || {})
      );
      formData.append(
        "tech_tool_match",
        JSON.stringify(candidate.tech_tool_match || [])
      );
      formData.append(
        "experience_match",
        JSON.stringify(candidate.experience_match || [])
      );
      formData.append("red_flags", JSON.stringify(candidate.red_flags || []));
      formData.append(
        "location_match",
        JSON.stringify(candidate.location_match || {})
      );
      formData.append("mobile", candidate.mobile || "");
      formData.append("orgid", org_id);
      if (jobConfig.customQuestions?.length) {
        formData.append(
          "custom_questions",
          JSON.stringify(jobConfig.customQuestions)
        );
      }

      // Timezone: always a valid IANA string (user-selected or system fallback)
      formData.append("timezone", resolvedTimezone);
      // Timeslot: "HH:MM AM/PM" string, or empty string (backend treats as null)
      formData.append("timeslot", resolvedTimeslot ?? "");

      await axios.post(`${host}/store_candidate_data`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      });

      return { id: candidate._id, status: "success" };
    } catch (error) {
      const detail = error?.response?.data?.detail;
      const isAlreadyScheduled =
        error?.response?.status === 400 &&
        typeof detail === "string" &&
        detail.toLowerCase().includes("already scheduled");
      return {
        id: candidate._id,
        name: candidate.name,
        status: isAlreadyScheduled ? "already_scheduled" : "error",
      };
    }
  });

  const results = await Promise.all(schedulePromises);

  const scheduledIds = results
    .filter((r) => r.status === "success")
    .map((r) => r.id);
  const alreadyScheduled = results.filter((r) => r.status === "already_scheduled");

  return {
    successCount: scheduledIds.length,
    skippedCount: candidates.length - results.length,
    alreadyScheduledCount: alreadyScheduled.length,
    alreadyScheduledNames: alreadyScheduled.map((r) => r.name),
    scheduledIds,
  };
};


// scope: "my_uploads" | "sourced" | "all"
// uniqueIds: selected My Uploads candidate unique_ids (bulk_candidates_collection)
// candidateIds: selected Applications Received candidate _ids (sourced_candidates_collection)
// Needs at least one id: an empty selection is refused here so it can never fall
// through to the backend, which exports every candidate in scope when both lists are empty.
export const exportCandidatesExcelService = async ({
  scope,
  uniqueIds = [],
  candidateIds = [],
}) => {
  if (uniqueIds.length === 0 && candidateIds.length === 0) {
    return false;
  }
  try {
    const accessToken = Cookies.get("accessToken");

    const response = await axios.post(
      `${host}/resumes/export`,
      {
        scope,
        unique_ids: uniqueIds,
        candidate_ids: candidateIds,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        responseType: "blob",
      }
    );

    const disposition = response.headers["content-disposition"];
    const filenameMatch = disposition && disposition.match(/filename="?([^"]+)"?/);
    const filename = filenameMatch
      ? filenameMatch[1]
      : `candidates_export_${new Date().toISOString().split("T")[0]}.xlsx`;

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Error occurred while exporting candidates to Excel", error);
    return false;
  }
};


export const deleteCandidateBulkUploadService = async ({
  uploadId,
  emails,
  uniqueId,
}) => {
  try {
    const accessToken = Cookies.get("accessToken");

    const response = await axios.delete(
      `${host}/deletecandidateBulkUpload`,
      {
        params: {
          upload_id: uploadId,
          emails,
          unique_id: uniqueId,
        },
        headers: {
          Authorization: `Bearer ${accessToken}`,
        }
      }
    );

    return response.data;
  } catch (error) {
    // Centralized error handling
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to delete candidate";

    console.error("Delete Candidate Error:", message);

    throw new Error(message);
  }
};



export const deleteCandidateSourcedService = async (ids) => {
  try {
    const accessToken = Cookies.get("accessToken");

    const response =await axios.delete(`${host}/sourced-candidates/delete`,
      {
        headers:{
          Authorization: `Bearer ${accessToken}`,
        },
        data: {
          candidate_ids: ids,
        },
        
      },
    )

    return  response.data
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to delete candidate";

    console.error("Delete Candidate Error:", message);

    throw new Error(message);
  }
}